import { datadogRum } from '@datadog/browser-rum'
import { DataDog } from '@/constants/datadog'

export default defineNuxtPlugin(() => {
  try {
    const config = useRuntimeConfig()

    datadogRum.init({
      applicationId: config.public.DATADOG_APP_ID,
      clientToken: config.public.DATADOG_CLIENT_TOKEN,
      site: DataDog.site,
      service: DataDog.service as string,
      env: config.public.DATADOG_ENVIRONMENT,
      sessionSampleRate: DataDog.sessionSampleRate as number,
      sessionReplaySampleRate: DataDog.sessionReplaySampleRate as number,
      defaultPrivacyLevel: DataDog.defaultPrivacyLevel,
      version: config.public.APP_VERSION
    })

    datadogRum.startSessionReplayRecording()
  } catch (e) {
    console.log(`Unable to initialize Datadog client: ${e}`)
  }
})
